import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { publicRequestAPI } from '../services/api';
import { useLanguage } from '../context/LanguageContext';
import { CASE_CATEGORIES } from '../constants/caseCategories';

const REGIONS = [
  'tashkent_city','tashkent','andijan','fergana','namangan',
  'samarkand','bukhara','navoi','kashkadarya','surkhandarya',
  'jizzakh','sirdarya','khorezm','karakalpakstan',
];
const REGION_LABELS_RU = {
  tashkent_city:'Ташкент (город)',tashkent:'Ташкентская область',
  andijan:'Андижанская область',fergana:'Ферганская область',
  namangan:'Наманганская область',samarkand:'Самаркандская область',
  bukhara:'Бухарская область',navoi:'Навоийская область',
  kashkadarya:'Кашкадарьинская область',surkhandarya:'Сурхандарьинская область',
  jizzakh:'Джизакская область',sirdarya:'Сырдарьинская область',
  khorezm:'Хорезмская область',karakalpakstan:'Республика Каракалпакстан',
};
const REGION_KEY_BY_RU = Object.fromEntries(Object.entries(REGION_LABELS_RU).map(([k,v])=>[v,k]));

const SUBREGIONS = {
  // Tashkent city has no district-level breakdown here — see LocationDropdown's
  // subs.length === 0 handling below, which selects the city directly on click.
  tashkent_city: [],
  tashkent: [
    { label: 'Нурафшон шаҳри',  value: 'г. Нурафшон' },
    { label: 'Чирчиқ шаҳри',    value: 'г. Чирчик' },
    { label: 'Олмалиқ шаҳри',   value: 'г. Алмалык' },
    { label: 'Ангрен шаҳри',    value: 'г. Ангрен' },
    { label: 'Бекобод шаҳри',   value: 'г. Бекабад' },
    { label: 'Янгийўл шаҳри',   value: 'г. Янгиюль' },
    { label: 'Зангиота тумани', value: 'Зангиатинский район' },
    { label: 'Қибрай тумани',   value: 'Кибрайский район' },
  ],
  andijan: [
    { label: 'Андижон шаҳри',     value: 'г. Андижан' },
    { label: 'Асака тумани',      value: 'Асакинский район' },
    { label: 'Хўжаобод тумани',   value: 'Ходжаабадский район' },
    { label: 'Жалолқудуқ тумани', value: 'Джалалкудукский район' },
    { label: 'Мархамат тумани',   value: 'Мархаматский район' },
  ],
  fergana: [
    { label: 'Фарғона шаҳри',  value: 'г. Фергана' },
    { label: 'Қўқон шаҳри',    value: 'г. Коканд' },
    { label: 'Марғилон шаҳри', value: 'г. Маргилан' },
    { label: 'Қува тумани',    value: 'Кувинский район' },
    { label: 'Риштон тумани',  value: 'Риштанский район' },
    { label: 'Бағдод тумани',  value: 'Багдадский район' },
  ],
  namangan: [
    { label: 'Наманган шаҳри',  value: 'г. Наманган' },
    { label: 'Тошлоқ тумани',   value: 'Ташлакский район' },
    { label: 'Чуст тумани',     value: 'Чустский район' },
    { label: 'Поп тумани',      value: 'Папский район' },
    { label: 'Косонсой тумани', value: 'Касансайский район' },
  ],
  samarkand: [
    { label: 'Самарқанд шаҳри',   value: 'г. Самарканд' },
    { label: 'Ургут тумани',      value: 'Ургутский район' },
    { label: 'Пайариқ тумани',    value: 'Пайарыкский район' },
    { label: 'Каттақўрғон шаҳри', value: 'г. Каттакурган' },
    { label: 'Иштихон тумани',    value: 'Иштиханский район' },
  ],
  bukhara: [
    { label: 'Бухоро шаҳри',   value: 'г. Бухара' },
    { label: 'Когон шаҳри',    value: 'г. Каган' },
    { label: 'Ромитан тумани', value: 'Ромитанский район' },
    { label: 'Қоракўл тумани', value: 'Каракульский район' },
    { label: 'Ғиждувон тумани',value: 'Гиждуванский район' },
  ],
  navoi: [
    { label: 'Навоий шаҳри',   value: 'г. Навои' },
    { label: 'Зарафшон шаҳри', value: 'г. Зарафшан' },
    { label: 'Учқудуқ тумани', value: 'Учкудукский район' },
    { label: 'Нурота тумани',  value: 'Нуратинский район' },
  ],
  kashkadarya: [
    { label: 'Қарши шаҳри',     value: 'г. Карши' },
    { label: 'Шаҳрисабз шаҳри', value: 'г. Шахрисабз' },
    { label: 'Китоб тумани',    value: 'Китабский район' },
    { label: 'Косон тумани',    value: 'Касанский район' },
    { label: 'Муборак тумани',  value: 'Мубарекский район' },
  ],
  surkhandarya: [
    { label: 'Термиз шаҳри',  value: 'г. Термез' },
    { label: 'Денов тумани',  value: 'Денауский район' },
    { label: 'Шеробод тумани',value: 'Шерабадский район' },
    { label: 'Бойсун тумани', value: 'Байсунский район' },
  ],
  jizzakh: [
    { label: 'Жиззах шаҳри',      value: 'г. Джизак' },
    { label: 'Зомин тумани',      value: 'Заминский район' },
    { label: 'Ғаллаорол тумани',  value: 'Галляаральский район' },
    { label: 'Янгиобод тумани',   value: 'Янгиабадский район' },
  ],
  sirdarya: [
    { label: 'Гулистон шаҳри', value: 'г. Гулистан' },
    { label: 'Хавос тумани',   value: 'Хавастский район' },
    { label: 'Сардоба тумани', value: 'Сардобинский район' },
  ],
  khorezm: [
    { label: 'Урганч шаҳри', value: 'г. Ургенч' },
    { label: 'Хива шаҳри',   value: 'г. Хива' },
    { label: 'Хонқа тумани', value: 'Ханкинский район' },
    { label: 'Шовот тумани', value: 'Шаватский район' },
  ],
  karakalpakstan: [
    { label: 'Нукус шаҳри',    value: 'г. Нукус' },
    { label: 'Тахиатош шаҳри', value: 'г. Тахиаташ' },
    { label: 'Беруний тумани', value: 'Берунийский район' },
    { label: 'Қўнғирот тумани',value: 'Кунградский район' },
  ],
};

// subregion Russian value → Uzbek label lookup (must be after SUBREGIONS)
const SUBREGION_LABEL = {};
Object.values(SUBREGIONS).forEach(subs => subs.forEach(s => { SUBREGION_LABEL[s.value] = s.label; }));

const UZ_MONTHS = ['январ','феврал','март','апрел','май','июн','июл','август','сентябр','октябр','ноябр','декабр'];
const formatDate = (dateStr, lang) => {
  const d = new Date(dateStr);
  const time = d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  if (lang === 'uz') return `${d.getDate()} ${UZ_MONTHS[d.getMonth()]} ${d.getFullYear()}, ${time}`;
  return `${d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })}, ${time}`;
};

// Hierarchical dropdown for practice area filter
const PracticeDropdown = ({ value, onChange, t }) => {
  const [open, setOpen] = useState(false);
  const [expandedCat, setExpandedCat] = useState(null);
  const ref = useRef(null);
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const select = (val) => { onChange(val); setOpen(false); setExpandedCat(null); };

  return (
    <div ref={ref} style={{ position: 'relative', flex: 1, minWidth: '200px' }}>
      <button type="button" onClick={() => setOpen(o => !o)} style={filterBtnStyle}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: value ? '#2d3748' : '#a0aec0' }}>
          {value ? value : 'Барча амалиётлар'}
        </span>
        <div style={{ display: 'flex', gap: '0.3rem', flexShrink: 0 }}>
          {value && <span onClick={e => { e.stopPropagation(); onChange(''); }} style={{ color: '#a0aec0' }}>×</span>}
          <svg width="10" height="6" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4" stroke="#718096" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </div>
      </button>
      {open && (
        <div style={dropdownStyle}>
          <DropItem active={!value} onClick={() => select('')}>Барча амалиётлар</DropItem>
          {CASE_CATEGORIES.map((cat, ci) => {
            const isExp = expandedCat === ci;
            const catActive = value === cat.label || cat.subs.includes(value);
            return (
              <React.Fragment key={cat.label}>
                <div
                  onClick={() => cat.subs.length === 0 ? select(cat.label) : setExpandedCat(isExp ? null : ci)}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f7fafc'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '0.6rem 1rem', cursor: 'pointer', fontSize: '0.92rem',
                    color: catActive ? '#2b6cb0' : '#2d3748',
                    fontWeight: catActive ? '600' : '400',
                  }}
                >
                  <span>{cat.label}</span>
                  {cat.subs.length > 0 && (
                    <svg width="10" height="6" viewBox="0 0 10 6" style={{ opacity: 0.5, flexShrink: 0, transform: isExp ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s' }}>
                      <path d="M1 1l4 4 4-4" stroke="#718096" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
                {isExp && (
                  <>
                    <div
                      onClick={() => select(cat.label)}
                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                      style={{ padding: '0.45rem 1rem 0.45rem 1.75rem', cursor: 'pointer', fontSize: '0.86rem', fontStyle: 'italic', color: value === cat.label ? '#2b6cb0' : '#718096', fontWeight: value === cat.label ? '600' : '400' }}
                    >
                      {cat.label} барчаси
                    </div>
                    {cat.subs.map(sub => (
                      <div
                        key={sub}
                        onClick={() => select(sub)}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f7fafc'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                        style={{ padding: '0.45rem 1rem 0.45rem 1.75rem', cursor: 'pointer', fontSize: '0.86rem', color: value === sub ? '#2b6cb0' : '#4a5568', fontWeight: value === sub ? '600' : '400' }}
                      >
                        {sub}
                      </div>
                    ))}
                  </>
                )}
              </React.Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
};

// Location filter dropdown with accordion subregions
const LocationDropdown = ({ value, onChange, t }) => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState({});
  const ref = useRef(null);
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const label = value ? (REGION_KEY_BY_RU[value] ? t(`regions.${REGION_KEY_BY_RU[value]}`) : value) : 'Барча ҳудудлар';

  const select = (val) => { onChange(val); setOpen(false); };
  const toggleExpand = (key, e) => { e.stopPropagation(); setExpanded(prev => ({ ...prev, [key]: !prev[key] })); };

  return (
    <div ref={ref} style={{ position: 'relative', flex: 1, minWidth: '200px' }}>
      <button type="button" onClick={() => setOpen(o => !o)} style={filterBtnStyle}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: value ? '#2d3748' : '#a0aec0' }}>{label}</span>
        <div style={{ display: 'flex', gap: '0.3rem', flexShrink: 0 }}>
          {value && <span onClick={e => { e.stopPropagation(); onChange(''); }} style={{ color: '#a0aec0' }}>×</span>}
          <svg width="10" height="6" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4" stroke="#718096" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </div>
      </button>
      {open && (
        <div style={{ ...dropdownStyle, maxHeight: '320px' }}>
          <DropItem active={!value} onClick={() => select('')}>Барча ҳудудлар</DropItem>
          {REGIONS.map(key => {
            const subs = SUBREGIONS[key] || [];
            const isExpanded = expanded[key];
            const regionActive = value === REGION_LABELS_RU[key];
            const anySubActive = subs.some(s => value === s.value);
            return (
              <React.Fragment key={key}>
                <div
                  onClick={(e) => subs.length === 0 ? select(REGION_LABELS_RU[key]) : toggleExpand(key, e)}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '0.6rem 1rem', cursor: 'pointer', fontSize: '0.92rem',
                    color: (regionActive || anySubActive) ? '#2b6cb0' : '#2d3748',
                    fontWeight: (regionActive || anySubActive) ? '600' : '400',
                  }}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f7fafc'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <span>{t(`regions.${key}`)}</span>
                  {subs.length > 0 && (
                    <svg width="10" height="6" viewBox="0 0 10 6" style={{ opacity: 0.5, flexShrink: 0, transform: isExpanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s' }}>
                      <path d="M1 1l4 4 4-4" stroke="#718096" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
                {isExpanded && subs.length > 0 && (
                  <>
                    <div
                      onClick={() => select(REGION_LABELS_RU[key])}
                      style={{ padding: '0.45rem 1rem 0.45rem 1.75rem', cursor: 'pointer', fontSize: '0.88rem', color: regionActive ? '#2b6cb0' : '#4a5568', fontWeight: regionActive ? '600' : '400' }}
                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      {t(`regions.${key}`)} (барчаси)
                    </div>
                    {subs.map(sub => (
                      <div
                        key={sub.value}
                        onClick={() => select(sub.value)}
                        style={{ padding: '0.45rem 1rem 0.45rem 1.75rem', cursor: 'pointer', fontSize: '0.88rem', color: value === sub.value ? '#2b6cb0' : '#4a5568', fontWeight: value === sub.value ? '600' : '400' }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f7fafc'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                      >
                        {sub.label}
                      </div>
                    ))}
                  </>
                )}
              </React.Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
};

const DropItem = ({ active, onClick, children }) => {
  const [hover, setHover] = useState(false);
  return (
    <div onClick={onClick} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
      style={{ padding: '0.6rem 1rem', fontSize: '0.92rem', cursor: 'pointer',
        color: active ? '#2b6cb0' : '#2d3748', fontWeight: active ? '600' : '400',
        backgroundColor: hover ? '#f7fafc' : 'transparent' }}>
      {children}
    </div>
  );
};

const filterBtnStyle = {
  width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  padding: '0.7rem 1rem', border: '1px solid #e2e8f0', borderRadius: '8px',
  backgroundColor: 'white', fontSize: '0.95rem', cursor: 'pointer',
};
const dropdownStyle = {
  position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 1000,
  backgroundColor: 'white', borderRadius: '10px', maxHeight: '260px', overflowY: 'auto',
  boxShadow: '0 8px 32px rgba(0,0,0,0.14)', border: '1px solid #e2e8f0', padding: '0.4rem 0',
};

const AttorneyRequests = () => {
  const { t, language } = useLanguage();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filterArea, setFilterArea] = useState('');
  const [filterLocation, setFilterLocation] = useState('');
  const [tier, setTier] = useState(null);

  const fetchRequests = (area, location) => {
    setLoading(true);
    const params = {};
    if (area) params.practiceArea = area;
    if (location) params.location = location;
    publicRequestAPI.getAll(params)
      .then(res => {
        setRequests(res.data.requests || []);
        setTier(res.data.tier || null);
      })
      .catch(() => setError(t('errors.requestsLoadError')))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchRequests('', ''); }, []);

  const handleAreaChange = (val) => { setFilterArea(val); fetchRequests(val, filterLocation); };
  const handleLocationChange = (val) => { setFilterLocation(val); fetchRequests(filterArea, val); };

  const translateLocation = (loc) => {
    if (!loc) return '—';
    const regionKey = REGION_KEY_BY_RU[loc];
    if (regionKey) return t(`regions.${regionKey}`);
    return SUBREGION_LABEL[loc] || loc;
  };

  return (
    <div style={{ maxWidth: '860px', margin: '0 auto', padding: '2rem' }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: '700', color: '#1a365d', marginBottom: '0.5rem' }}>
          Мижозлар сўровлари
        </h1>
        <p style={{ color: '#718096', fontSize: '1rem' }}>
          Адвокат излаётган мижозларнинг сўровлари
        </p>
      </div>

      {/* Free-tier notice */}
      {tier === 'free' && (
        <div style={{ backgroundColor: '#fffbeb', border: '1px solid #f59e0b', borderRadius: '10px', padding: '1rem 1.25rem', marginBottom: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#92400e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <p style={{ margin: 0, color: '#92400e', fontSize: '0.92rem', flex: 1 }}>
            Телефон рақамларини тўлиқ кўриш учун Pro режасига ўтинг.
          </p>
          <Link to="/subscription" style={{ backgroundColor: '#f59e0b', color: 'white', padding: '0.4rem 1rem', borderRadius: '8px', textDecoration: 'none', fontSize: '0.85rem', fontWeight: '700', whiteSpace: 'nowrap' }}>
            Pro га ўтиш
          </Link>
        </div>
      )}

      {/* Filters */}
      <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '1.25rem 1.5rem', boxShadow: '0 2px 4px rgba(0,0,0,0.08)', marginBottom: '1.5rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        <PracticeDropdown value={filterArea} onChange={handleAreaChange} t={t} />
        <LocationDropdown value={filterLocation} onChange={handleLocationChange} t={t} />
      </div>

      {loading && <div style={{ textAlign: 'center', padding: '3rem', color: '#718096' }}>Юкланмоқда...</div>}
      {error && <div style={{ backgroundColor: '#fed7d7', color: '#c53030', padding: '1rem', borderRadius: '8px' }}>{error}</div>}

      {!loading && !error && requests.length === 0 && (
        <div style={{ textAlign: 'center', padding: '3rem', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.08)', color: '#718096' }}>
          Ҳозирча сўровлар йўқ
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {requests.map(req => (
          <div key={req.id} style={{ backgroundColor: 'white', borderRadius: '12px', padding: '1.5rem', boxShadow: '0 2px 4px rgba(0,0,0,0.08)', borderLeft: '4px solid #FFD700' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
              <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1a365d', margin: 0 }}>
                {req.practice_area}
              </h3>
              <span style={{ fontSize: '0.8rem', color: '#a0aec0', whiteSpace: 'nowrap', marginLeft: '1rem' }}>
                {formatDate(req.created_at, language)}
              </span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#718096" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                <span style={{ fontSize: '0.95rem', color: '#4a5568' }}>{translateLocation(req.location)}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#718096" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.48 2 2 0 0 1 3.58 1.27h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 9a16 16 0 0 0 6.06 6.06l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                {!req.phone ? (
                  <span style={{ fontSize: '0.9rem', color: '#a0aec0', fontStyle: 'italic' }}>Яширилган</span>
                ) : req.phone_masked ? (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.95rem', color: '#a0aec0', filter: 'blur(2px)', userSelect: 'none' }} title="Pro режасида кўринади">
                    {req.phone}
                  </span>
                ) : (
                  <a href={`tel:${req.phone}`} style={{ fontSize: '0.95rem', color: '#3182ce', textDecoration: 'none', fontWeight: '600' }}>
                    {req.phone}
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AttorneyRequests;
